<div class="ai-design-chat">
  <div class="chat-transcript" #transcriptEl aria-live="polite">
    @if (messages.length === 0) {
      <p class="chat-intro">
        Describe the design you want and I'll add it to your box. Try
        "make a blue box with white snowflakes" or "put a floral pattern on the top".
      </p>
    }
    @for (message of messages; track $index) {
      <div class="chat-message" [ngClass]="message.role">
        <p>
          {{ message.text }}
          @if (message.reference) {
            <span class="ref-code">[{{ message.reference }}]</span>
          }
        </p>
        @if (message.role === 'question' && message.options?.length) {
          <div class="chat-question-options">
            @for (option of message.options; track option) {
              <button type="button" class="chat-option-chip" [disabled]="isGenerating" (click)="selectOption(option)">
                {{ option }}
              </button>
            }
          </div>
        }
      </div>
    }
    @if (isGenerating) {
      <div class="chat-message assistant pending" role="status">
        <p>Designing&hellip;</p>
      </div>
    }
  </div>

  <form (ngSubmit)="submit()" class="chat-input-row">
    <textarea
      #promptTextarea
      name="prompt"
      rows="2"
      [(ngModel)]="prompt"
      [placeholder]="promptPlaceholder"
      [disabled]="isGenerating"
      [class.focus-ring]="showPromptFocusRing"
      (keydown)="onPromptKeydown($event)"
      (input)="autoGrowTextarea()"
      (mousedown)="onPromptMouseDown()"
      (focus)="onPromptFocus()"
      (blur)="onPromptBlur()"
      autocomplete="off"
      aria-label="Describe the design you want"
    ></textarea>
    <div class="chat-input-actions">
      @if (messages.length > 0) {
        <button
          type="button"
          class="clear-chat-button"
          (click)="clear()"
          [disabled]="isGenerating"
          aria-label="Clear conversation and start fresh"
          matTooltip="Start new chat"
          matTooltipPosition="above"
          matTooltipClass="ai-chat-tooltip"
        >
          <i class="fa-sharp fa-light fa-arrows-rotate"></i>
        </button>
      }
      <button
        type="submit"
        class="send-button"
        [disabled]="isGenerating || !prompt.trim()"
        aria-label="Send"
        matTooltip="Submit prompt"
        matTooltipPosition="above"
        matTooltipClass="ai-chat-tooltip"
      >
        <i class="fa-sharp fa-light fa-paper-plane"></i>
      </button>
    </div>
  </form>
</div>
